import * as React from 'react';
import styles from './tooltip.scss';
import { createPortal } from 'react-dom';

export interface TooltipProps extends React.PropsWithChildren {
  title?: string;
  center?: boolean;
  narrow?: boolean;
  wide?: boolean;
  delayed?: boolean;
  className?: string;
  direction?: TooltipDirections;
  colorLight?: boolean;
  onClick?: () => void;
  portalTarget?: HTMLElement;
}

export enum TooltipDirections {
  default,
  top,
  left,
  right,
  bottom
}

export class Tooltip extends React.Component<React.PropsWithChildren<TooltipProps>, any> {
  public tooltipRef = React.createRef<HTMLDivElement>();
  constructor(props: TooltipProps) {
    super(props);
    this.state = {
      isVisible: false
    };
  }

  public splitTooltip(text: string) {
    // Two ways for detecting the line breaks
    if (text.indexOf('\n') > -1) {
      return text.split('\n');
    }
    return text.split('\\n');
  }

  onMouseOver = (event: React.MouseEvent<HTMLDivElement>) => {
    const rect = event?.currentTarget?.getBoundingClientRect() || { top: 0, left: 0, width: 0 };
    const parentRect = this.props.portalTarget?.getBoundingClientRect() || { top: 0, left: 0 };
    const top = (rect.top - parentRect.top) +
      this.tooltipRef.current?.offsetHeight;
    const left = (rect.left - parentRect.left) - 75; // 75 is half of the tooltip-container max width - offset
    this.setState({
      isVisible: true,
      top,
      left
    });
  };

  onMouseOut = ()=> {
    this.setState({ isVisible: false });
  };

  public render() {
    const { title, children, className, onClick, center, narrow, wide, delayed, direction, colorLight, portalTarget } = this.props;
    const { top, left } = this.state;
    const positionStyle = portalTarget ? { top, left } : {};
    const tooltip = <div className={`tooltip-text ${styles.tooltiptext}`}>
      {title && this.splitTooltip(title).map((text, index) => <p key={index}>{text}</p>)}
    </div>;

    const tooltipContainer = <div className={`${styles.tooltipContainer} 
      ${this.state.isVisible ? styles.tooltipVisible : styles.tooltipHidden} ${portalTarget ? styles.withPortalTarget : ''}`}
      style={positionStyle}>
      {!!title && <div className={`${styles.tooltipArrow}`} />}
      {!!title && tooltip}
    </div>;

    const classNames = [
      styles.tooltip,
      className,
      center && styles.center,
      narrow && styles.narrow,
      wide && styles.wide,
      delayed && styles.delayed,
      colorLight && styles.colorLight,
      (direction && direction === TooltipDirections.left) && styles.left,
      (direction && direction === TooltipDirections.right) && styles.right,
      (direction && direction === TooltipDirections.top) && styles.top,
      (direction && direction === TooltipDirections.bottom) && styles.narrow
    ].filter(item => item);

    return (<div className={classNames.join(' ')} onClick={onClick} onMouseOver={this.onMouseOver} onMouseOut={this.onMouseOut}
      ref={this.tooltipRef}>
      {children}
      {portalTarget ? createPortal(tooltipContainer, portalTarget) : tooltipContainer}
    </div>);
  }
}
